import { useAuth } from '@contexts/AuthContext';
import type { LeagueKey } from '@parlay-picker/shared/league';
import {
  type ChoosableBookId,
  isEuGameMarketSportsbookId,
  isSportsbook,
  sportsbookForLeague,
  sportsbookPreferenceKey,
} from '@parlay-picker/shared/sportsbook';
import { useCallback } from 'react';

export interface UseLeagueSportsbookResult {
  sportsbook: ChoosableBookId;
  setSportsbook: (book: string) => Promise<void>;
}

/** The user's book for a league, and a setter that saves it under that league's key. */
export function useLeagueSportsbook(leagueKey: LeagueKey): UseLeagueSportsbookResult {
  const { user, updatePreferences } = useAuth();
  const sportsbook = sportsbookForLeague(user?.preferences, leagueKey);

  const setSportsbook = useCallback(
    async (book: string) => {
      if (sportsbookPreferenceKey(leagueKey) === 'preferredEuSportsbook') {
        if (isEuGameMarketSportsbookId(book))
          await updatePreferences({ preferredEuSportsbook: book });
      } else if (isSportsbook(book)) {
        await updatePreferences({ preferredSportsbook: book });
      }
    },
    [leagueKey, updatePreferences],
  );

  return { sportsbook, setSportsbook };
}
